import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useLocation } from 'react-router';
import { getError, getSearchTemplateResults } from 'store/selectors/templates';
import { getCategories } from 'store/selectors/categories';
import Templates from './Templates';
import {
  useCreateTemplate,
  useDeleteTemplate,
  useUpdateTemplate,
} from '../../../mutation/template';
import { useGetAllEmailTypes } from '../../../query/mail';
import qs from 'query-string';

const selector = createStructuredSelector({
  error: getError,
  categories: getCategories,
  searchTemplateResults: getSearchTemplateResults,
});

export default function(props) {
  const selectorProps = useSelector(selector);
  const location = useLocation(),
    { id } = qs.parse(location.search);
  const {
    mutate: mutateCreateTemplate,
    ...createTemplateMutation
  } = useCreateTemplate();
  const {
    mutate: mutateUpdateTemplate,
    ...updateTemplateMutation
  } = useUpdateTemplate();
  const {
    mutate: mutateDeleteTemplate,
    ...deleteTemplateMutation
  } = useDeleteTemplate();
  const { data: emailTypesData } = useGetAllEmailTypes();
  const isLoading =
    createTemplateMutation.isLoading ||
    updateTemplateMutation.isLoading ||
    deleteTemplateMutation.isLoading;
  return useMemo(() => {
    return (
      <Templates
        {...props}
        {...selectorProps}
        activeTemplate={id}
        emailTypes={emailTypesData}
        isLoading={isLoading}
        onAddTemplate={mutateCreateTemplate}
        onDeleteTemplate={mutateDeleteTemplate}
        onEditTemplate={mutateUpdateTemplate}
      />
    );
  }, [selectorProps, isLoading, emailTypesData, id]);
}
